module.exports = __webpack_public_path__ + "img/user.c5690e26.png";